import React, { FC } from "react";
import type { ClearingInstitutionsHeroProps } from "@/types";
import { SwiperCoverflow } from "../swiper";
import { TextCols } from "../text-cols";

export const ClearingInstitutionsHero: FC<ClearingInstitutionsHeroProps> = ({
  label,
  title,
  description,
  gallery,
}) => {
  return (
    <section className="clearingInstitutionsHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description.textCol1,
            textCol2: description.textCol2,
          }}
          maxTitleWidth={937}
        />
      </div>
      <SwiperCoverflow
        slides={gallery}
        className="clearingInstitutionsHero--swiper"
      />
    </section>
  );
};
